import {omit, difference, keys, keyBy, createReducer, generate, map, castArray} from 'helpers';
import {RootState, Actions} from 'store/types';
import {updateProgress, remove} from '../actions/goals';
import {ServerActions} from 'store/server';

const actions = {remove, updateProgress};

export const progress = createReducer<RootState['goals']['progress'], Actions<typeof actions> | ServerActions>({}, {
  GOALS_SET_PROGRESS: (state, action) => {
    const record = {
      goal_id: action.goalId,
      timestamp: action.ts,
      id: generate(),
      ...action.progressIndex[action.goalId + '_' + action.ts],
      value: parseFloat(action.value),
    }
    if (!record.value) {
      return omit(state, record.id);
    }
    return {
      ...state,
      [record.id]: record,
    }
  },

  GOALS_DELETE: (state, action) => {
    const data = castArray(action.progressIndex[action.id] || []);
    if (data.length) {
      return omit(state, map(data, 'id'));
    }
    return state;
  },

  SERVER_DATA_RECEIVED: (state, action) => {
    const removed = difference(keys(state), action.existingElementIds.goalProgress);
    if (action.goalProgress.length || removed.length) {
      return omit({
        ...state,
        ...keyBy(action.goalProgress, 'id'),
      }, removed);
    }
    return state;
  },

  SERVER_DATA_RECEIVED_AFTER: (state) => state,

  TESTING_DELETE_ALL: () => ({}),
});
